import React, { useEffect, useState, useRef } from "react";
import { secretKey } from "../.././data";
import LoadingPopup from "../helpers/loading_component.js";
import { faEdit, faEye, faDeleteLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import AddCheckListLawsuitQst from "./addCheckListLawsuitQst";
const MySwal = withReactContent(Swal2);

const AdminPanelLettersLawsuit = (props) => {
  const [letters, setLetters] = useState([]);
  const [name, setName] = useState([]);
  const [opt1, setOpt1] = useState("TAK");
  const [opt2, setOpt2] = useState("TAK");
  const [opt3, setOpt3] = useState("TAK");
  const [type, setType] = useState("CHF");
  const [qst, setQst] = useState("");
  const [file, setFile] = useState([]);
  const [nameEdit, setNameEdit] = useState([]);
  const [opt1Edit, setOpt1Edit] = useState("");
  const [opt2Edit, setOpt2Edit] = useState("");
  const [opt3Edit, setOpt3Edit] = useState("");
  const [qstEdit, setQstEdit] = useState("");
  const [typeEdit, setTypeEdit] = useState("CHF");
  const [fileEdit, setFileEdit] = useState([]);
  const [edit, setEdit] = useState("");
  const [loading, setLoading] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [questionsSKD, setQuestionsSKD] = useState([]);

  const fetchQuestions = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getQuestionsCHF", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var qstX = [];
        data.map((e, index) => {
          var obj = { question: e.name, result: "NIE", index: index };
          qstX.push(obj);
        });
        setQst(qstX);
        setQuestions(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const fetchLetters = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getLettersLawsuit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLetters(data.filter((el) => el.type === "CHF"));
        fetchQuestions();
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const getData = () => {
    setLoading(true);
    setEdit("");
    setName("");
    setOpt1("TAK");
    setOpt2("TAK");
    setOpt3("TAK");
    setFile("");
    setNameEdit("");
    setFileEdit("");
    fetchLetters();
  };

  useEffect(() => {
    getData();
  }, []);

  const sendFiles = async (e) => {
    setLoading(true);
    if (!file || name.length === 0) {
      MySwal.fire({
        icon: "error",
        title: "Uzupełnij",
        text: "dane pisma",
      }).then((result) => {
        getData();
        return;
      });
    } else {
      let formData = new FormData();
      formData.append("file", file);
      formData.append("name", name);
      formData.append("opt1", opt1);
      formData.append("opt2", opt2);
      formData.append("opt3", opt3);
      formData.append("type", "CHF");
      formData.append("questions", JSON.stringify(qst));

      await fetch("https://apidevkppp.ftpeople.pl/uploadLetterLawsuit", {
        method: "POST",
        body: formData,
      })
        .then((response) => response.text())
        .then((data) => {
          MySwal.fire({
            icon: "success",
            title: "Dodano",
            text: "pismo",
          }).then((result) => {
            getData();
          });
        })
        .catch((error) => {});
    }
  };

  const editFiles = async (e) => {
    setLoading(true);
    if (!fileEdit || nameEdit.length === 0) {
      MySwal.fire({
        icon: "error",
        title: "Uzupełnij",
        text: "dane pisma",
      }).then((result) => {
        getData();
        return;
      });
    } else {
      let formData = new FormData();
      formData.append("file", fileEdit);
      formData.append("name", nameEdit);
      formData.append("opt1", opt1Edit);
      formData.append("opt2", opt2Edit);
      formData.append("opt3", opt3Edit);
      formData.append("type", "CHF");
      formData.append("questions", JSON.stringify(qstEdit));
      formData.append("id", e.target.value);

      await fetch("https://apidevkppp.ftpeople.pl/editLetterLawsuit", {
        method: "POST",
        body: formData,
      })
        .then((response) => response.text())
        .then((data) => {
          MySwal.fire({
            icon: "success",
            title: "Edytowano",
            text: "pismo",
          }).then((result) => {
            getData();
          });
        })
        .catch((error) => {});
    }
  };

  const deleteFiles = async (e) => {
    setLoading(true);

    var body = {
      id: e.target.value,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteLetterLawsuit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then((data) => {
        MySwal.fire({
          icon: "success",
          title: "Usunięto",
          text: "pismo",
        }).then((result) => {
          getData();
        });
      })
      .catch((error) => {});
  };

  return (
    <>
      <div className="mainContainerPayments">
        {loading ? (
          <>
            <LoadingPopup />
          </>
        ) : (
          <>
            <div className="closeBox">
              <button className="closeClientButton" onClick={props.close}>
                X
              </button>
            </div>
            {true ? (
              <>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    alignItems: "center",
                    marginBottom: "2vh",
                  }}
                >
                  <div
                    style={{
                      width: "20%",
                      textAlign: "left",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <input
                      style={{ marginTop: "20px" }}
                      multiple={false}
                      type="file"
                      onChange={(e) => {
                        setFile(e.target.files[0]);
                      }}
                    />
                  </div>
                  <div style={{ width: "15%", textAlign: "left" }}>
                    <p
                      style={{
                        margin: "0",
                        marginBottom: "1px",
                        fontWeight: "600",
                        fontSize: ".8vw",
                        paddingLeft: "20px",
                      }}
                    >
                      nazwa
                    </p>
                    <input
                      type="text"
                      id="asdasd"
                      style={{
                        height: "3vh",
                        width: "100%",
                        padding: "0px 10px",
                        boxSizing: "border-box",
                        height: "3vh",
                      }}
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                  {questions.map((q, index) => (
                    <>
                      <div style={{ width: "18%", textAlign: "left" }}>
                        <p
                          style={{
                            margin: "0",
                            marginBottom: "1px",
                            fontWeight: "600",
                            fontSize: ".8vw",
                            paddingLeft: "20px",
                          }}
                        >
                          {q.name}
                        </p>
                        <select
                          type="text"
                          style={{
                            height: "3vh",
                            width: "100%",
                            padding: "0px 10px",
                            boxSizing: "border-box",
                            height: "3vh",
                          }}
                          value={
                            qst.filter((e) => e.index === index)[0]
                              ? qst.filter((e) => e.index === index)[0].result
                              : "TAK"
                          }
                          onChange={(e) => {
                            if (qst.filter((e) => e.index === index)[0]) {
                              qst.filter((e) => e.index === index)[0].result =
                                e.target.value;
                            }
                          }}
                        >
                          <option key={0} value={"TAK"}>
                            {"TAK"}
                          </option>
                          <option key={1} value={"NIE"}>
                            {"NIE"}
                          </option>
                        </select>
                      </div>
                    </>
                  ))}
                </div>

                <div
                  style={{
                    marginBottom: "5vh",
                    display: "flex",
                    gap: "10px",
                  }}
                >
                  <button
                    style={{
                      backgroundColor: "#00bdce",
                      border: "none",
                      color: "white",
                      fontWeight: "600",
                      borderRadius: "15px",
                    }}
                    id="clientsFilterButton"
                    className="paymentMenuButton"
                    onClick={sendFiles}
                  >
                    Dodaj
                  </button>
                </div>
              </>
            ) : (
              ""
            )}
            {letters.length === 0 ? (
              "BRAK PISM W SYSTEMIE"
            ) : (
              <>
                {letters.map((el, index) => (
                  <>
                    <div
                      style={
                        el.questions
                          ? el.questions.length === 0
                            ? {
                                width: "80%",
                                padding: "3vh 1vw",
                                backgroundColor: "red",
                                color: "white",
                                borderRadius: "15px",
                                fontSize: "1vw",
                                display: "flex",
                                alignItems: "center",
                                marginTop: "1vh",
                              }
                            : {
                                width: "80%",
                                padding: "3vh 1vw",
                                backgroundColor: "lightgray",
                                borderRadius: "15px",
                                fontSize: "1vw",
                                display: "flex",
                                alignItems: "center",
                                marginTop: "1vh",
                              }
                          : {
                              width: "80%",
                              padding: "3vh 1vw",
                              backgroundColor: "red",
                              color: "white",
                              borderRadius: "15px",
                              fontSize: "1vw",
                              display: "flex",
                              alignItems: "center",
                              marginTop: "1vh",
                            }
                      }
                    >
                      <div style={{ width: "40%" }}>Nazwa: {el.name}</div>
                      <div style={{ width: "40%" }}>Link: {el.link}</div>
                      <div
                        style={{ width: "20%", display: "flex", gap: "10px" }}
                      >
                        <button
                          style={{
                            backgroundColor: "white",
                            border: "none",
                            color: "black",
                            fontWeight: "600",
                            borderRadius: "15px",
                          }}
                          id="clientsFilterButton"
                          className="paymentMenuButton"
                          onClick={
                            edit === index
                              ? () => setEdit("")
                              : () => {
                                  setEdit(index);
                                  try {
                                    var qstQ = JSON.parse(el.questions);

                                    if (qstQ === null) {
                                      var qstX = [];
                                      questions.map((e, index) => {
                                        var obj = {
                                          question: e.name,
                                          result: "NIE",
                                          index: index,
                                        };
                                        qstX.push(obj);
                                      });
                                      setQstEdit(qstX);
                                    } else {
                                      setQstEdit(qstQ);
                                    }
                                  } catch (err) {
                                    var qstX = [];
                                    questions.map((e, index) => {
                                      var obj = {
                                        question: e.name,
                                        result: "NIE",
                                        index: index,
                                      };
                                      qstX.push(obj);
                                    });
                                    setQstEdit(qstX);
                                  }
                                  setNameEdit(el.name);
                                  setOpt1Edit(el.opt1);
                                  setOpt2Edit(el.opt2);
                                  setOpt3Edit(el.opt3);
                                }
                          }
                        >
                          {edit === index ? "Zwiń" : "Edytuj"}
                        </button>
                        {true ? (
                          <button
                            style={{
                              backgroundColor: "white",
                              border: "none",
                              color: "black",
                              fontWeight: "600",
                              borderRadius: "15px",
                            }}
                            id="clientsFilterButton"
                            className="paymentMenuButton"
                            value={el.id}
                            onClick={deleteFiles}
                          >
                            Usuń
                          </button>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    {edit === index ? (
                      <>
                        <div
                          style={{
                            width: "80%",
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                            marginBottom: "2vh",
                            marginTop: "1vh",
                          }}
                        >
                          <div
                            style={{
                              width: "45%",
                              textAlign: "left",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <input
                              style={{ marginTop: "20px" }}
                              multiple={false}
                              type="file"
                              onChange={(e) => {
                                setFileEdit(e.target.files[0]);
                              }}
                            />
                          </div>
                          <div style={{ width: "45%", textAlign: "left" }}>
                            <p
                              style={{
                                margin: "0",
                                marginBottom: "1px",
                                fontWeight: "600",
                                fontSize: ".8vw",
                                paddingLeft: "20px",
                              }}
                            >
                              nazwa
                            </p>
                            <input
                              type="text"
                              style={{
                                height: "3vh",
                                width: "100%",
                                padding: "0px 10px",
                                boxSizing: "border-box",
                                height: "3vh",
                              }}
                              value={nameEdit}
                              onChange={(e) => setNameEdit(e.target.value)}
                            />
                          </div>
                          {questions.map((q, index) => (
                            <div style={{ width: "45%", textAlign: "left" }}>
                              <p
                                style={{
                                  margin: "0",
                                  marginBottom: "1px",
                                  fontWeight: "600",
                                  fontSize: ".8vw",
                                  paddingLeft: "20px",
                                }}
                              >
                                {q.name}
                              </p>
                              <select
                                type="text"
                                style={{
                                  height: "3vh",
                                  width: "100%",
                                  padding: "0px 10px",
                                  boxSizing: "border-box",
                                  height: "3vh",
                                }}
                                value={
                                  qstEdit.filter((e) => e.index === index)[0]
                                    ? qstEdit.filter(
                                        (e) => e.index === index
                                      )[0].result
                                    : "TAK"
                                }
                                onChange={(e) => {
                                  if (
                                    qstEdit.filter((e) => e.index === index)[0]
                                  ) {
                                    qstEdit.filter(
                                      (e) => e.index === index
                                    )[0].result = e.target.value;
                                  }
                                }}
                              >
                                <option key={0} value={"TAK"}>
                                  {"TAK"}
                                </option>
                                <option key={1} value={"NIE"}>
                                  {"NIE"}
                                </option>
                              </select>
                            </div>
                          ))}
                        </div>

                        <div
                          style={{
                            marginBottom: "5vh",
                            display: "flex",
                            gap: "10px",
                          }}
                        >
                          <button
                            style={{
                              backgroundColor: "#00bdce",
                              border: "none",
                              color: "white",
                              fontWeight: "600",
                              borderRadius: "15px",
                            }}
                            id="clientsFilterButton"
                            className="paymentMenuButton"
                            value={el.id}
                            onClick={editFiles}
                          >
                            Edytuj
                          </button>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </>
                ))}
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default AdminPanelLettersLawsuit;
